import * as z from 'zod';

import { RadioButtonOptionsProps } from 'components/RadioButton/RadioButton';

export const SLUG_VALID_REGEX = /^(?!.*-$)[\p{L}0-9-]+$/u;

export enum EContentRadioButtonOptions {
  HIDDEN = 'hidden',
  VISIBLE = 'visible',
  SCHEDULED = 'scheduled'
}

export const CONTENT_RADIO_BUTTON_OPTIONS: RadioButtonOptionsProps[] = [
  {
    value: EContentRadioButtonOptions.VISIBLE,
    id: EContentRadioButtonOptions.VISIBLE,
    label: 'Visible'
  },
  {
    value: EContentRadioButtonOptions.HIDDEN,
    id: EContentRadioButtonOptions.HIDDEN,
    label: 'Hidden'
  }
];

export enum EContentTypeOptions {
  NEWS = 'news',
  ARTICLE = 'article'
}

export const CONTENT_TYPE_OPTIONS = [
  {
    label: 'News',
    value: EContentTypeOptions.NEWS
  },
  {
    label: 'Article',
    value: EContentTypeOptions.ARTICLE
  }
];

export enum EVisibilityOptions {
  PUBLIC = 'public',
  SEGMENTED = 'segmented'
}

export const VISIBILITY_OPTIONS = [
  {
    label: 'Public',
    value: EVisibilityOptions.PUBLIC
  },
  {
    label: 'Segmented',
    value: EVisibilityOptions.SEGMENTED
  }
];

export const CONTENT_FORM_SCHEMA = z.object({
  title: z.string().trim().min(1, 'This field is required.'),
  subTitle: z.string().optional(),
  contentType: z.string().min(1, { message: 'Content type is required.' }),
  bodyText: z.string().optional(),
  headerImage: z.string().trim().min(1, 'This field is required.'),
  thumbnailImage: z.string().trim().min(1, 'This field is required.'),
  pages: z.array(z.string()).optional(),
  labels: z
    .array(z.string().min(1, 'This field is required.'))
    .nonempty('This field is required.'),
  visibility: z.string().min(1, { message: 'Visibility is required.' }),
  slug: z
    .string()
    .optional()
    .refine((val) => !val || SLUG_VALID_REGEX.test(val), {
      message:
        'This field can only contain letters, numbers, and hyphens. Cannot end with a hyphen.'
    }),
  state: z.enum([
    EContentRadioButtonOptions.VISIBLE,
    EContentRadioButtonOptions.HIDDEN,
    EContentRadioButtonOptions.SCHEDULED
  ]),
  publishDate: z.string().optional(),
  isPublishDateEnabled: z.boolean().optional()
});

export const DEFAULT_PAGE_OPTION = 'Select page';
